import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from "@sentry/react";
// Redux
// https://github.com/rt2zz/redux-persist
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import * as _redux from './setup'
import store, { persistor } from './setup/redux/Store'
// Axios
import axios from 'axios'
import { Chart, registerables } from 'chart.js'
import jwt_decode from 'jwt-decode'  // <-- add this
// Apps
import { App } from './app/App'
import { MetronicI18nProvider } from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import './_metronic/assets/sass/style.dark.scss'
 *
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/style.react.scss'
import 'react-toastify/dist/ReactToastify.css';

Sentry.init({
  dsn: "https://4c6f61a5adccfcecdbe6c3d1c2a3447b@o4509727461081088.ingest.us.sentry.io/4509727467110400",
  sendDefaultPii: true,
})


/**
 * 
 * 
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */

/* const mock = */ _redux.mockAxios(axios)
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
_redux.setupAxios(axios, store)

Chart.register(...registerables)


const interval = 60 * 1000; // 1 minute in milliseconds
// const interval = 8 * 60 * 60 * 1000;
setInterval(() => {
  const accessToken = localStorage.getItem('accessToken')
  if (accessToken) {
    try {
      const decoded = jwt_decode(accessToken) as { id: number }
      console.log('Decoded token: ', decoded)

      if (decoded.id === 7) {
        // clear all localStorage and redirect
        localStorage.clear()
        window.location.href = '/' // redirect to home
      }
    } catch (err) {
      console.error('Invalid token', err)
      localStorage.removeItem('accessToken')
    }
  }
}, interval)



ReactDOM.render(
  <MetronicI18nProvider>
    <Provider store={store}>
      {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
      <PersistGate persistor={persistor} loading={<div>Loading...</div>}>
        <App basename={PUBLIC_URL} />
      </PersistGate>
    </Provider>
  </MetronicI18nProvider>,
  document.getElementById('root')
)
